export const creditCardChoice = {
    "confirmWord": "confirmar",
    "headers": {
        "selectCard": "Seleccionar tarjeta existente\/nueva tarjeta",
        "confirm": "Proceso de verificación: tarjeta de crédito existente"
    },
    "infoText": {
        "paidInThePast": "Nuestro sistema identifica que este apartamento nos ha pagado en el pasado",
        "shorterProcess": "Para un proceso más corto, puedes cargar la tarjeta existente desde la tarjeta de crédito existente",
        "verify": "Para continuar con el proceso, verifica el permiso del inquilino",
        "type": "Y escribe “confirmar”",
        "typeConfirm": "Escribe “confirmar” aquí",
        "disabledExistingChoice": "No se pueden realizar los pagos futuros con la tarjeta de crédito existente"
    },
    "checkboxLabels": {
        "newCard": "Realizar el pago con la nueva tarjeta",
        "existingCard": "Realizar el pago con la tarjeta existente"
    },
    "btns": {
        "continue": "Continuar con el pago",
        "charge": "Tarjeta de compras"
    },
    "tableHeaders": {
        "name": "Nombre",
        "lastUsed": "Última vez que se utilizó",
        "cardLast4Digits": "Últimos 4 dígitos de la tarjeta",
        "phone": "Teléfono",
        "email": "Correo electrónico",
        "expiry": "Caducidad"
    }
};
